import useAuth from "app/hooks/useAuth";
import AllPages from "app/routes";
import { flat } from "app/utils/utils";
import { Navigate, useLocation } from "react-router-dom";

const userHasPermission = (pathname, routes, permissions) => {
  const matched = routes.find((r) => r.path === pathname);
  const authenticated =
    matched && matched.permission && matched.permission.length
      ? permissions.includes(matched.permission)
      : true;
  return authenticated;
};
const AuthGuard = ({ children }) => {
  const { isAuthenticated, permissions, loggedOut } = useAuth();
  const { pathname } = useLocation();
  const routes = flat(AllPages);
  const hasPermission = userHasPermission(pathname, routes, permissions);
  let authenticated = isAuthenticated && hasPermission;

  return (
    <>
      {authenticated ? (
        children
      ) : (
        <Navigate replace to="/session/signin" state={{ from: pathname }} />
      )}
    </>
  );
};

export default AuthGuard;
